<div class="container-fluid">
    <div class="card mt-3">
        <div class="card-body">
            <div class="row justify-content-center">
                <div class="col-12 text-center">
                    <div class="page-nonet">
                        <div class="nonet-bg"></div>

                        <div class="contant-box-nonet">
                            <h2> No Internet </h2>
                            <p>Please check your connection status and try again</p>
                            <a href="index" class="btn btn-primary px-5">Close</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
